import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useEnv } from '@zenbusiness/application-commons-env';

export const useBankingPath = (suffix = '') => {
  const { businessEntityUuid } = useBusinessEntity();

  const { PARENT_SEGMENT = '/nope' } = useEnv();

  return `${PARENT_SEGMENT}/${businessEntityUuid}/banking${suffix}`;
};
